import Link from "next/link";

export default function VirtualInline({ mode }) {
  return (
    <div className="mt-8 md:mt-4 mx-auto">
      <div className="p-2 rounded-lg bg-red-600 shadow-lg sm:p-3">
        <div className="flex items-center justify-between flex-wrap">
          <div className="sm:w-0 flex-1 flex items-center">
            <span className="flex p-2 rounded-lg bg-red-800">
              <svg
                className="h-6 w-6 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                />
              </svg>
            </span>
            {mode === "festival" ? (
              <p className="ml-4 font-medium text-white">
                Ready to take all or part of your film festival online? Eventive
                for Film Festivals integrates seamlessly with{" "}
                <span className="font-bold">Eventive Virtual</span>, which
                includes studio-grade DRM security, native TV apps, and more for
                virtual and hybrid film experiences.
              </p>
            ) : mode === "cinema" ? (
              <p className="ml-4 font-medium text-white">
                Ready to take all or part of your arthouse showings online?
                Eventive for Arthouse Cinema integrates seamlessly with{" "}
                <span className="font-bold">Eventive Virtual</span>, which
                includes studio-grade DRM security, native TV apps, and more for
                virtual and hybrid film experiences.
              </p>
            ) : mode === "distributor" ? (
              <p className="ml-4 font-medium text-white">
                Eventive for Distributors is powered by Eventive Virtual, a
                fully white-label virtual screening solution.
              </p>
            ) : null}
          </div>
          <div className="order-2 mt-2 flex-shrink-0 w-full sm:ml-4 sm:mt-0 sm:w-auto">
            <div className="rounded-md shadow-sm">
              <Link href="/virtual">
                <a className="flex items-center justify-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-red-600 bg-white hover:text-red-500 focus:outline-none focus:shadow-outline transition ease-in-out duration-150">
                  Learn more about virtual
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
